import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { AGENCY_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_VEHICLES_LIST = '_LOAD_VEHICLES_LIST';
export const CREATE_VEHICLES = '_CREATE_VEHICLES';
export const LOAD_VEHICLES_BY_ID = '_LOAD_VEHICLES_BY_ID';
export const EDIT_VEHICLES_BY_ID = '_EDIT_VEHICLES_BY_ID';
export const DELETE_VEHICLES = '_DELETE_VEHICLES';

export const loadVehiclesList = createDeferredAction(AGENCY_MODULE + LOAD_VEHICLES_LIST);
export const loadVehiclesListBegin = createDeferredAction(AGENCY_MODULE + LOAD_VEHICLES_LIST + BEGIN);
export const loadVehiclesListSuccessful = createAction(AGENCY_MODULE + LOAD_VEHICLES_LIST + SUCCESSFUL);
export const loadVehiclesListFailed = createAction(AGENCY_MODULE + LOAD_VEHICLES_LIST + FAILED);

export const createVehicles = createDeferredAction(AGENCY_MODULE + CREATE_VEHICLES);
export const createVehiclesSuccessful = createAction(AGENCY_MODULE + CREATE_VEHICLES + SUCCESSFUL);
export const createVehiclesFailed = createAction(AGENCY_MODULE + CREATE_VEHICLES + FAILED);

export const loadVehiclesById = createDeferredAction(AGENCY_MODULE + LOAD_VEHICLES_BY_ID);
export const loadVehiclesByIdSuccessful = createAction(AGENCY_MODULE + LOAD_VEHICLES_BY_ID + SUCCESSFUL);
export const loadVehiclesByIdFailed = createAction(AGENCY_MODULE + LOAD_VEHICLES_BY_ID + FAILED);
export const loadVehiclesByIdClear = createDeferredAction(AGENCY_MODULE + LOAD_VEHICLES_BY_ID + CLEAR);

export const editVehiclesById = createDeferredAction(AGENCY_MODULE + EDIT_VEHICLES_BY_ID);
export const editVehiclesByIdSuccessful = createAction(AGENCY_MODULE + EDIT_VEHICLES_BY_ID + SUCCESSFUL);
export const editVehiclesByIdFailed = createAction(AGENCY_MODULE + EDIT_VEHICLES_BY_ID + FAILED);

export const deleteVehicles = createDeferredAction(AGENCY_MODULE + DELETE_VEHICLES);
export const deleteVehiclesSuccessful = createAction(AGENCY_MODULE + DELETE_VEHICLES + SUCCESSFUL);
export const deleteVehiclesFailed = createAction(AGENCY_MODULE + DELETE_VEHICLES + FAILED);
